// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainAfter, addToChainBefore, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import {
    chain,
    DispatchCompleteLoadCart,
    ExecuteOnSuccessCallback,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const pageType = getCurrentPage(props.getState()).type;
    const shouldAppendMiniCartExpands =
        !props.parameter.shouldLoadFullCart &&
        !(
            pageType === "CheckoutShippingPage" ||
            pageType === "CheckoutReviewAndSubmitPage" ||
            pageType === "CartPage" ||
            pageType === "OnePageCheckoutPage" ||
            pageType === "RfqRequestQuotePage"
        );

    if (!props.needFullCart && shouldAppendMiniCartExpands) {
        const expands = (props.apiParameter.expand || []).concat(["cartLines", "restrictions", "paymentOptions"]);
        props.apiParameter.expand = [...new Set(expands)] as typeof props.apiParameter.expand;
    }
};

export const LoadCartLinesAvailability: typeof DispatchCompleteLoadCart = async props => {
    let cartLines = props.apiResult.cart.cartLines;

    if (!cartLines || cartLines.length === 0) {
        return;
    }

    const cartLinesIds = cartLines.map(o => o.productId || "");
    let loadedInventory = false;
    props.dispatch(
        loadRealTimeInventory({
            productIds: cartLinesIds,
            onComplete: realTimeInventoryProps => {
                if (!realTimeInventoryProps.error) {
                    const inventories = realTimeInventoryProps?.apiResult?.realTimeInventoryResults;
                    cartLines = cartLines?.map(cartLine => {
                        cartLine.properties["globalInventory"] =
                            inventories?.filter(invenory => invenory.productId === cartLine.productId)?.[0]
                                ?.additionalResults?.globalInventory || "";
                        return cartLine;
                    });
                    props.apiResult.cart.cartLines = cartLines;
                }
                loadedInventory = true;
            },
        }),
    );

    await waitFor(() => loadedInventory);
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToChainBefore(chain, DispatchCompleteLoadCart, LoadCartLinesAvailability);
